<cac-dialog-layout [title]="data.banner ? 'Edit Banner' : 'Create New Banner'"
    subtitle="Enter the required data and save" [form]="form" (onSubmit)="onSubmit($event)">

    <div class="p-6">
        <!-- Image Upload -->
        <div class="mb-6">
            <label class="block text-sm font-medium text-gray-700 mb-2">
                Banner Image
                <span class="text-red-500">*</span>
            </label>
            <cac-image-uploader [control]="image" [options]="options" class="h-44" />

            <!-- Error message for image field -->
            @if (image.invalid && image.touched) {
            <div class="mt-1 text-sm text-red-600">
                Banner image is required
            </div>
            }
        </div>

        <!-- Form Fields -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Title Fields -->
            <cac-field [control]="form.controls.titleEn" label="Title English" controlType="input" class="col-span-1" />

            <cac-field [control]="form.controls.titleAr" label="Title Arabic" controlType="input" class="col-span-1" />

            <!-- Description Fields -->
            <cac-field [control]="form.controls.descriptionEn" label="Description English" controlType="textarea"
                class="col-span-1" />

            <cac-field [control]="form.controls.descriptionAr" label="Description Arabic" controlType="textarea"
                class="col-span-1" />

            <!-- Target and Type -->
            <cac-field [control]="form.controls.target" label="Target" controlType="select" [items]="targetItems"
                class="col-span-1" />

            <cac-field [control]="form.controls.type" label="Link Type" controlType="select" [items]="typeItems"
                class="col-span-1" />

            <!-- Category Field (shown when type is Category) -->
            @if (shouldShowCategoryField()) {
            <cac-field [control]="form.controls.categoryId" label="Category" controlType="select"
                [items]="categoryItems$" [searchable]="true" class="col-span-2" />
            }

            <!-- Product Field (shown when type is Product) -->
            @if (shouldShowProductField()) {
            <div class="col-span-2">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Product
                    <span class="text-red-500">*</span>
                </label>
                <app-lazy-dropdown
                    [multiple]="false"
                    [clearable]="true"
                    [searchable]="true"
                    placeholder="Select a product..."
                    [initialIds]="getCurrentSelectedProductIds()"
                    [apiAdapter]="productApiAdapter"
                    [itemMapper]="productItemMapper"
                    idsFilterKey="ProductIds"
                    searchField="EnglishName"
                    duplicateMessage="Product is already selected"
                    [showCustomTemplate]="true"
                    (selectionChange)="onProductSelectionChange($event)" />

                <!-- Error message for product field -->
                @if (form.controls.productId.invalid && form.controls.productId.touched) {
                <div class="mt-1 text-sm text-red-600">
                    Product is required
                </div>
                }
            </div>
            }

            <!-- Brand Field (shown when type is Brand) -->
            @if (shouldShowBrandField()) {
            <cac-field [control]="form.controls.brandId" label="Brand" controlType="select"
                [items]="brandItems$" [searchable]="true" class="col-span-2" />
            }

            <!-- Rail Field (shown when type is Rail) -->
            @if (shouldShowRailField()) {
            <cac-field [control]="form.controls.railId" label="Rail" controlType="select"
                [items]="railItems$" [searchable]="true" class="col-span-2" />
            }

            <!-- Order -->
            <cac-field [control]="form.controls.order" label="Order" type="number" class="col-span-2" />

            <!-- Status -->
            <cac-switch [control]="form.controls.status" label="Enable" class="col-span-2" />
        </div>
    </div>
</cac-dialog-layout>